import { removeIncompatibleSearchParameters } from "@helpers/removeIncompatibleSearchParameters"
import {
	foulingPageSearchSchema,
	validateConsumptionSearchParams,
} from "@routes/clients.$clientName/_sopPageLayout/efficiency"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_sopPageLayout/efficiency")({
	component: RouteComponent,
	validateSearch: validateConsumptionSearchParams,
	search: {
		middlewares: [removeIncompatibleSearchParameters(foulingPageSearchSchema)],
	},
})

function RouteComponent() {
	return null
}
